type Value = string | number | boolean

export const compareValues = <T extends Value>(a: T, b: T): number => {
  if (a === b) return 0

  return a > b ? 1 : -1
}
